var $ = require('../internals/export'); // `Math.signbit` method
// https://github.com/tc39/proposal-Math.signbit


$({
  target: 'Math',
  stat: true
}, {
  signbit: function signbit(x) {
    return (x = +x) == x && x == 0 ? 1 / x == -Infinity : x < 0;
  }
});